import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/home";

const RoutesConfig = () => {
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
      </Routes>
    </div>
  );
};

export default RoutesConfig;